import {MultiValidationError} from "../errors/multi-validation-error";
import {WorkbookMissingColumnsError} from "../errors/workbook-missing-columns-error";
import {ValidationError} from "../errors/validation-error";
import {AccessDeniedError} from "../errors/access-denied-error";
import {UnauthorizedError} from "../errors/unauthorized-error";
import {HttpEvent} from "@angular/common/http";
import {HttpResponse} from "@angular/common/http/src/response"; // eslint-disable-line import/no-unresolved
import {ErrorLikeObject} from "../errors/error-like-object";
import {CDFValidationError} from "../errors/cdf-validation-error";

export function getErrorFromJson(obj: any): ErrorLikeObject {
  if (obj instanceof Error) return obj;
  if (!obj || !obj["error"] || typeof obj["error"] !== "object") return undefined;
  return obj["error"] as ErrorLikeObject;
}

export function detectErrors<T>(json: T): T {
  if (typeof json !== "object") return json;

  const errorObject = getErrorFromJson(json);

  if (errorObject) {
    if (MultiValidationError.check(errorObject)) {
      throw new MultiValidationError(errorObject);
    }

    if (ValidationError.check(errorObject)) {
      throw new ValidationError(errorObject);
    }

    if (AccessDeniedError.check(errorObject)) {
      throw new AccessDeniedError(errorObject);
    }

    if (WorkbookMissingColumnsError.check(errorObject)) {
      throw new WorkbookMissingColumnsError(errorObject);
    }

    if (CDFValidationError.check(errorObject)) {
      throw new CDFValidationError(errorObject);
    }

    if (errorObject instanceof Error) {
      throw errorObject;
    }

    throw new Error(errorObject["message"]);
  }

  return json;
}

export function handleResponseStatusError(error: any): never {
  if (error.status === 401) {
    const redirectFn = window["LOGIN_REDIRECT"];

    if (typeof redirectFn === "function") {
      redirectFn();
    }

    throw new UnauthorizedError(error);
  }

  if (error.status === 403) {
    const throwable = new Error("You are not authorized to do this.");
    throwable["response"] = error;

    throw throwable;
  }

  if (error instanceof Error) {
    throw error;
  }

  const throwable = new Error("An unexpected error occurred.");
  throwable["response"] = error;

  throw throwable;
}

export function handleResponseBodyError<T>(obj: HttpEvent<T>) {
  if (obj && obj.type === 4) {
    detectErrors((obj as HttpResponse<T>).body);
  }

  return obj;
}
